// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  contractId: __t.u64().primaryKey().name("contract_id"),
  worldId: __t.u64().name("world_id"),
  assetId: __t.u64().name("asset_id"),
  graphJson: __t.string().name("graph_json"),
  bytecode: __t.string(),
  bytecodeRef: __t.string().name("bytecode_ref"),
  bytecodeSig: __t.string().name("bytecode_sig"),
  capsRequested: __t.string().name("caps_requested"),
  capsGranted: __t.string().name("caps_granted"),
  cpuBudgetMs: __t.u32().name("cpu_budget_ms"),
  memBudgetKb: __t.u32().name("mem_budget_kb"),
  state: __t.string(),
  throttleUntil: __t.timestamp().name("throttle_until"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
